import { ORIGIN_COLORS } from "@/data";

export function getBookingColor(originName: string) {
  const normalized = originName.trim().toLowerCase();

  return (
    ORIGIN_COLORS[normalized] ||
    (normalized.includes("airbnb")
      ? ORIGIN_COLORS["airbnb"]
      : normalized.includes("booking")
      ? ORIGIN_COLORS["booking"]
      : ORIGIN_COLORS["default"])
  );
}
